import React, { useEffect, useState } from 'react'
import { useLocation, useParams, Link } from "react-router-dom";
import { getOneUser } from '../../../helpers/Api'; 
import MainLayout from "../../../components/MainLayout";
import TabPerfiles from './components/TabPerfiles';
import Historico from './components/Historico';
import Generales from './components/Generales';
import Usuarios from './components/Usuarios';
import Documentos from "./components/Documentos";
import TabAdminAaaver from '../ListadoAgentes/TabAdminAaaver';

const PerfilAgente = () => {
  let location = useLocation();
  const user = useParams();
  const token = localStorage.getItem("token");


  const [userName, setUserName] = useState('')

  useEffect(() => {
    getUser();
  }, [])


  const getUser = async () => {
    try {
      const response =  await getOneUser(user.id, token);
      if(response){
        setUserName(response?.agencia_aduanal);
      }
    } catch (error) {
      throw error
    }
  }


  return (
    <MainLayout>
    <div className="row title_layout">
      <div className="col-6">
        <h5>PERFIL DE AGENTE ADUANAL</h5>
      </div>
      <div className="col-6 d-flex flex-row-reverse">
        <TabAdminAaaver />
      </div>
    </div>
    <div className="card_form">
     <TabPerfiles />
     {location.hash === "#generales" ? <Generales /> : 
      location.hash === "#historico" ?  <Historico /> :
      location.hash === "#documentos" ?  <Documentos /> :
     <Usuarios />
     }
    </div>
  </MainLayout>
  )
}

export default PerfilAgente